var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"src":"https://docs.google.com/forms/d/e/1FAIpQLSeGjV80IxTdnd2s8KDOf-oJG_eK_L5HVlR1MS0LQzcuscjcQg/viewform?embedded=true","frameborder":"0","marginheight":"0","marginwidth":"0"}},[_vm._v("読み込んでいます…")])
}
var staticRenderFns = []

export { render, staticRenderFns }